import { ILoginWithUserResponse } from '../ilogin-with-user';

export interface IJwtAuthGuardRequest {
    user: ILoginWithUserResponse;
}